<template>
  <div>
    <a-modal
      class="modal-zalora"
      centered
      :visible="showModalForm"
      :closable="false"
      :width="showSuccessIntegrate ? 400 : 900"
      :footer="false"
    >
      <div class="mb-4 text-center">
        <img :src="require(`@/assets/store/add-store/zalora.svg`)" style="width: 200px; height: auto; margin: 0 auto" />
      </div>
      <a-form-model ref="formZalora" :model="form" :rules="rules">
        <a-row :gutter="24">
          <a-col :span="8">
            <p class="mb-1" style="font-weight: 500">
              {{ $t('add_store.complete_information') }}:
            </p>
            <a-form-model-item prop="id" label="Client ID" class="mb-1">
              <a-input
                v-model="form.id"
                size="large"
                placeholder="Client ID"
                allow-clear
                :disabled="loadingSync"
              />
            </a-form-model-item>
            <a-form-model-item prop="secret" label="Client Secret" class="mb-1">
              <a-input
                v-model="form.secret"
                size="large"
                placeholder="Client Secret"
                allow-clear
                :disabled="loadingSync"
              />
            </a-form-model-item>
            <a-form-model-item prop="warehouse" label="Warehouse Master" class="mb-1">
              <a-select
                v-model="form.warehouse"
                size="large"
                class="w-100 select-antd-default"
                show-search
                allow-clear
                :options="warehouseList"
                option-filter-prop="children"
                :filter-option="filterOption"
                :placeholder="$t('store_list_page.detail.warehouse_master')"
                :disabled="loadingSync"
              />
            </a-form-model-item>
            <a-form-model-item prop="confirm" class="mb-1">
              <a-checkbox v-model="form.confirm" size="large" :disabled="loadingSync">
                {{ $t('store_list_page.auto_accept_order') }}
              </a-checkbox>
            </a-form-model-item>
            <a-alert
              type="info"
              show-icon
              style="font-size: 12px;"
              :message="$t('add_store.zalora_sync.alert_msg')"
            />
            <a-form-model-item
              v-if="!!form.confirm"
              prop="shipment"
              :label="$t('add_store.zalora_sync.select_shipment_label')"
              class="mb-1"
              :rules="[{ required: !!form.confirm, message: $t('add_store.zalora_sync.select_shipment_required') }]"
            >
              <a-select
                v-model="form.shipment"
                size="large"
                class="w-100 select-antd-default"
                show-search
                allow-clear
                option-filter-prop="children"
                :filter-option="filterOption"
                :placeholder="$t('add_store.zalora_sync.select_shipment_placeholder')"
                :disabled="loadingSync"
              >
                <a-select-option v-for="item in shipmentList" :key="item.value" :value="item.value">
                  <span>{{ item.label }}</span>
                  <span class="text-desc">
                    <a-tooltip :title="item.tooltip">
                      <a-icon class="ml-2" type="info-circle" />
                    </a-tooltip>
                  </span>
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="16">
            <div style="padding: 15px; background-color: #e9ecef">
              <p class="mb-2" style="font-size: 13px">
                <b>{{ $t('add_store.zalora_sync.how_to_get_title') }}</b>
              </p>
              <ul class="mb-4 pl-3 text-left">
                <li class="text-desc text-li">
                  {{ $t('add_store.zalora_sync.step_1') }}
                </li>
                <li class="text-desc text-li">
                  {{ $t('add_store.zalora_sync.step_2') }}
                </li>
                <li class="text-desc text-li">
                  {{ $t('add_store.zalora_sync.step_3') }}
                </li>
                <li class="text-desc text-li">
                  {{ $t('add_store.zalora_sync.step_4') }}
                </li>
                <li class="text-desc text-li">
                  {{ $t('add_store.zalora_sync.step_5') }}
                </li>
                <li class="text-desc text-li">
                  {{ $t('add_store.zalora_sync.step_6') }}
                  <ul>
                    <li>{{ $t('add_store.zalora_sync.step_6_li_1') }}</li>
                    <li>{{ $t('add_store.zalora_sync.step_6_li_2') }}</li>
                  </ul>
                </li>
                <li class="text-desc text-li">
                  {{ $t('add_store.zalora_sync.step_7') }}
                </li>
                <li class="text-desc text-li">
                  {{ $t('add_store.zalora_sync.step_8') }}
                </li>
                <li class="text-desc text-li">
                  {{ $t('add_store.zalora_sync.step_9') }}
                </li>
              </ul>
            </div>
            <div class="mt-4 text-center">
              <a-button
                size="large"
                class="mr-4"
                style="width: 200px"
                :disabled="loadingSync"
                @click="typeof back !== 'undefined' && back(), openModal(null)"
              >
                {{ $t('add_store.back') }}
              </a-button>
              <a-button
                type="primary"
                size="large"
                class="mr-4"
                style="width: 200px"
                :loading="loadingSync"
                @click.prevent="handleAuthorize"
              >
                {{ $t('add_store.start_sync') }}
              </a-button>
            </div>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>

    <a-modal
      :visible="showModalSuccess"
      :closable="false"
      :width="360"
      :footer="false"
    >
      <div class="text-center">
        <img :src="require(`@/assets/store/add-store/success-add.svg`)" style="width:60px !important; height:60px !important;" />
        <h4 class="mt-4">
          {{ $t('add_store.blibli_sync.authorization_success_title') }}
        </h4>
        <div class="mt-2 w-100 text-center">
          {{ $t('add_store.blibli_sync.authorization_success_desc') }}
        </div>
        <a-button
          type="primary"
          size="large"
          class="mt-4 w-100"
          @click.prevent="refreshPage"
        >
          OK
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getWarehouseList } from '@/api/warehouse'
import { authorizeZalora } from '@/api/channels/zalora'
import { rulesSyncZalora } from '@/data/rules'
import data from '@/services/store/data'

export default {
  name: 'ModalSyncZalora',
  props: {
    visible: Boolean,
    back: Function,
    openModal: Function,
    openModalSuccess: Function,
    idData: Number,
  },
  data() {
    return {
      rules: rulesSyncZalora,
      form: {
        id: '',
        secret: '',
        warehouse: undefined,
        confirm: true,
        shipment: undefined,
      },
      showModalForm: false,
      showModalSuccess: false,
      loadingZalora: false,
      loadingSync: false,
      showSuccessIntegrate: false,
      warehouseList: [],
      shipmentList: [
        { value: 'SALES_ITEMS_BOOKED', label: this.$t('add_store.zalora_sync.sales_items_booked.label'), tooltip: this.$t('add_store.zalora_sync.sales_items_booked.tooltip') },
        { value: 'PICK_CONFIRMED', label: this.$t('add_store.zalora_sync.pick_confirmed.label'), tooltip: this.$t('add_store.zalora_sync.pick_confirmed.tooltip') },
        // { value: 'PACKING_COMPLETED', label: 'Pengemasan', tooltip: 'Pengemasan: atur pengiriman pada zalora akan di set saat barang telah dikemas' },
      ],
    }
  },
  computed: {
    detailData() {
      return data.find((val) => val.id === this.idData)
    },
    integration() {
      return this.$store.state.integration
    },
  },
  watch: {
    visible(value) {
      this.showModalForm = value
      if(value) this.init()
    },
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase())
    },
    showNotification(type, message) {
      this.$notification[type]({
        message: type === 'success' ? this.$t('add_store.blibli_sync.success_title') : this.$t('add_store.blibli_sync.fail_title'),
        description: message,
      })
    },
    refreshPage() {
      window.location.reload()
    },
    async init() {
      this.form = {
        id: '',
        secret: '',
        warehouse: undefined,
        confirm: true,
        shipment: undefined,
      }
      await Promise.all([this.fetchWarehouseList()])
    },
    async fetchWarehouseList() {
      await getWarehouseList({
        business_id: this.$route.query.business_id,
        warehouse_id: this.$route.query.warehouse_id,
      })
      .then(({ data: { data: warehouses } }) => this.warehouseList = warehouses.map(warehouse => ({
        value: warehouse.id,
        label: warehouse.name,
      })))
      .catch(() => this.warehouseList = [])
    },
    handleAuthorize() {
      this.$refs.formZalora.validate(async valid => {
        if (valid) {
          this.loadingSync = true
          await authorizeZalora({
            access_key: '1234567890',
            business_id: this.$route.query.business_id,
            data: {
              client_id: this.form.id,
              client_secret: this.form.secret,
              country_code: 'ID',
              channel_connection_function: 'MASTER',
              warehouse: {
                default_warehouse_id: this.form.warehouse,
                auto_accept: this.form.confirm,
                channel_order_auto_accept_step: this.form.shipment || 'PICK_CONFIRMED',
                time_zone: 'asia/jakarta',
              },
            },
          })
          .then(({ data }) => {
            this.showModalForm = false
            this.showModalSuccess = true
          })
          .catch(err => this.showNotification('error', err.response?.data?.message || err.message))
          .finally(() => this.loadingSync = false)
        }
      })
    },
  },
}
</script>

<style lang="scss">
.select-antd-default.ant-select-lg .ant-select-selection__rendered {
  line-height: 38px !important;
}
.text-step {
  display: block;
  font-size: 14px;
  font-weight: bold;
  margin: 15px 0 5px -15px;
  color: #2196F3;
}
.text-li {
  text-align: left;
  color: #5d5e5f;
  font-size: 14px;
  line-height: 2;

  i {
    font-size: 14px !important;
    font-weight: bold !important;
    color: #5d5e5f !important;

    &.anticon-loading {
      color: #FF0A54 !important;
    }
  }
}
.modal-zalora {
  // .ant-modal-body {
  //   padding: 20px !important;
  // }

  .ant-btn {
    i {
      font-size: 16px !important;
      font-weight: bold !important;
      color: #ffffff !important;
    }
  }

  .ant-input-suffix i {
    font-size: 14px !important;
    color: rgba(0, 0, 0, 0.45) !important;

    &:hover {
      color: rgba(0, 0, 0, 0.9) !important
    }
}
}
</style>
<style lang="scss" scoped>
.form-disclaimer {
  color: var(--kit-color-primary);
  font-style: italic !important;
}

.warehouse-zalora {
  &-header {
    padding: 12px 0;
    font-weight: 600;
    background: #e9ecef;
  }

  &-list {
    padding-top: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e4e9f0;
  }
}
</style>